import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext();
const KEY = "eg_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.slug === product.slug);
      if (existing) {
        return prev.map((i) => (i.slug === product.slug ? { ...i, quantity: i.quantity + qty } : i));
      }
      return [
        ...prev,
        {
          slug: product.slug, name: product.name, quantity: qty,
          price: product.sale_price || product.price, thumbnail: product.thumbnail, category: product.category,
        },
      ];
    });
    toast.success(`${product.name} added to cart`);
    setOpen(true);
  };

  const remove = (slug) => setItems((prev) => prev.filter((i) => i.slug !== slug));
  const setQty = (slug, qty) =>
    setItems((prev) => prev.map((i) => (i.slug === slug ? { ...i, quantity: Math.max(1, qty) } : i)));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, count, subtotal, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
